import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import { BrandingLogos } from 'types';
import ResolveImage from 'components/ResolveImage';
import useMatchMedia from 'hooks/useMatchMedia';

import './BrandingLogo.styles.scss';

type BrandingLogoProps = {
  className?: string;
  withBorderRadius?: boolean;
  brandingLogos: BrandingLogos;
  height: number;
};

const BrandingLogo: React.FC<BrandingLogoProps> = (props) => {
  const { className, brandingLogos, height, withBorderRadius = false } = props;

  const isPhablet = useMatchMedia('isPhablet');

  const [aspectRatio, setAspectRatio] = useState(isPhablet ? '1' : '2');

  const { logo, mobileLogo } = brandingLogos || {};

  const classes = classNames(
    'branding-logo',
    { 'border-radius': withBorderRadius },
    className,
  );

  const logoSrc = useMemo(() => {
    if (!logo && !mobileLogo) return undefined;

    if (isPhablet && mobileLogo) return mobileLogo?.url;

    return logo?.url;
  }, [isPhablet, logo, mobileLogo]);

  const getImageSize = useCallback(
    (naturalWidth: number, naturalHeight: number) => {
      setAspectRatio(`${naturalWidth}/${naturalHeight}`);
    },
    [],
  );

  const rootProps = useMemo(
    () => ({
      style: {
        aspectRatio,
        height,
        minHeight: height,
        maxHeight: height,
        minWidth: height,
        maxWidth: 2 * height,
      },
    }),
    [aspectRatio, height],
  );

  if (!logoSrc) return null;

  return (
    <ResolveImage
      rootProps={rootProps}
      src={logoSrc}
      className={classes}
      asCompanyLogo
      getImageSize={getImageSize}
    />
  );
};

export default BrandingLogo;
